// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.modal-title-text[data-v-64214a47] {
  color: #5a9e6f;
  font-weight: 400;
  font-size: 1.25rem;
}
.details-modal-content[data-v-64214a47] {
  padding: 0;
  width: 100%;
}
.origin-destination-card[data-v-64214a47] {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px 20px;
  margin-bottom: 15px;
  width: 100%;
}
.origin-destination-row[data-v-64214a47] {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}
.origin-badge[data-v-64214a47] {
  background-color: #5a9e6f !important;
  font-weight: 500;
  padding: 5px 12px;
  border-radius: 15px;
}
.destination-badge[data-v-64214a47] {
  background-color: #6c9ec4 !important;
  font-weight: 500;
  padding: 5px 12px;
  border-radius: 15px;
}
.client-name[data-v-64214a47] {
  font-weight: 500;
  color: #333;
}
.arrow-icon[data-v-64214a47] {
  color: #5a9e6f;
  margin: 0 5px;
}
.results-table-container[data-v-64214a47] {
  margin-bottom: 12px;
  width: 100%;
}
.scope-badges[data-v-64214a47] {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: center;
}
.scope-badge[data-v-64214a47] {
  background-color: #717171 !important;
  font-weight: 500;
  font-size: 0.75rem;
}
.table-status-badge[data-v-64214a47] {
  font-weight: 500;
  font-size: 0.82rem;
}
.process-status-list[data-v-64214a47] {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}
.process-status-item[data-v-64214a47] {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px 16px;
}
.process-info[data-v-64214a47] {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  gap: 5px;
}
.process-module[data-v-64214a47] {
  font-weight: 600;
  color: #5a9e6f;
  font-size: 0.9rem;
}
.process-message[data-v-64214a47] {
  color: #666;
  font-size: 0.85rem;
  font-style: italic;
}
.summary-section[data-v-64214a47] {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  margin-top: 0;
  margin-bottom: 16px;
  width: 100%;
}
.error-section[data-v-64214a47] {
  margin-bottom: 16px;
  width: 100%;
}
.error-summary-card[data-v-64214a47] {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 14px 16px 18px;
}
.error-card-header[data-v-64214a47] {
  text-align: left;
  margin-bottom: 14px;
}
.summary-header[data-v-64214a47] {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}
.info-icon[data-v-64214a47] {
  color: #1f8fff;
  font-size: 1rem;
}
.summary-title[data-v-64214a47] {
  font-weight: 600;
  font-size: 1.1rem;
  color: #2d2d2d;
}
.summary-description[data-v-64214a47] {
  color: #666;
  font-size: 0.8rem;
  margin: 0;
  padding-left: 1.5rem;
  line-height: 1.35;
}
.error-state-content[data-v-64214a47] {
  text-align: center;
  padding: 10px 6px 2px;
}
.error-icon-wrapper[data-v-64214a47] {
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.error-icon-x-circle[data-v-64214a47] {
  color: #E67774;
  font-size: 5rem;
}
.error-state-title[data-v-64214a47] {
  font-weight: 700;
  font-size: 1.25rem;
  color: #111;
  margin-bottom: 8px;
}
.error-state-message[data-v-64214a47] {
  color: #222;
  font-size: 0.95rem;
}
.button-container[data-v-64214a47] {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  width: 100%;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
